export default __webpack_public_path__ + "static/media/ISEO CLASS-8 EXAM PATTERN 2025.ec27ae8e.pdf";